import Vue from 'vue'
import uiConfirm from './uiConfirm.vue'

const VueComponent = Vue.extend(uiConfirm)
const vm = new VueComponent().$mount()
let init = false
let defaultOptions = {}

const confirm = function (options) {
  Object.assign(vm, defaultOptions, options, {
    type: 'confirm'
  })

  if (!init) {
    document.body.appendChild(vm.$el)
    init = true
  }
  return vm.confirm('el')
}

export default confirm


// WEBPACK FOOTER //
// ./src/component/uiConfirm/index.js